import { render, staticRenderFns } from "./MapMagic.vue?vue&type=template&id=1d19b6d5&"
import script from "./MapMagic.vue?vue&type=script&lang=ts&"
export * from "./MapMagic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports